// extracted by mini-css-extract-plugin
export default {"root":"ReceiveReceiptPopup_root__npg9X","receipt":"ReceiveReceiptPopup_receipt__43j5H","submit":"ReceiveReceiptPopup_submit__cvGYe"};